.section-notification {
  align-items: center;
  background-color: var(--color-orange-100);
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  padding: 0.75rem 1rem;
}

.section-notification--fullwidth {
  width: 100%;
}
